import {
  decodePercentEncodedS3KeyParam,
  encodeEvidenceLockerStyleProxyUriSegment,
  sanitizeHttpUrlForBrowserLoad,
} from "@/shared/functions";

/**
 * Resolve storage paths, ``s3://`` keys, or absolute HTTP URLs to something the
 * browser can load (proxy path or passthrough).
 */
export function storageUrlForDisplay(
  url: string | undefined | null,
): string {
  const t = (url ?? "").trim();
  if (!t) return "";
  if (t.startsWith("data:") || t.startsWith("blob:")) return t;
  if (t.startsWith("/api/proxy/")) {
    const tail = t.slice("/api/proxy/".length).split("?")[0];
    const query = t.includes("?") ? t.slice(t.indexOf("?")) : "";
    return `/api/proxy/${encodeEvidenceLockerStyleProxyUriSegment(decodePercentEncodedS3KeyParam(tail))}${query}`;
  }
  if (/^https?:\/\//i.test(t)) return sanitizeHttpUrlForBrowserLoad(t);
  return `/api/proxy/${encodeEvidenceLockerStyleProxyUriSegment(t)}`;
}
